<template>
    <div class="add-work-email">
        <div class="content">
            <div class="data-title">
                <div class="title-name">新增工作邮箱</div>
            </div>
            <div class="text">基本信息</div>
            <div class="forms">
                <el-form :inline="true" :model="form" ref="form" :rules="rules" class="form" size="small"
                    label-width="96px" autocomplete="off">
                    <el-form-item label="工作邮箱" prop="account">
                        <el-input v-model="form.account" placeholder="请输入" maxlength="256" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱密码" prop="password">
                        <el-input type="text" style="display: none;" autocomplete="username">
                        </el-input>
                        <el-input v-model="form.password" autocomplete="new-password" placeholder="请输入" maxlength="24"
                            :type="eye ? 'text' : 'password'">
                            <i slot="suffix" :class="[eye ? 'i-eye' : 'i-eye-hide']" @click="onEye"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="邮箱实名人" class="t-label">
                        <template #label>
                            <div class="custom-label">邮箱<br />实名人</div>
                        </template>
                        <el-input v-model="form.name" placeholder="请输入" clearable maxlength="30" type="textarea"
                            style="width: 204px;" rows="3" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱 绑定手机号" prop="hasPhone" class="label-star">
                        <template #label>
                            <div class="custom-label">是否绑定<br />手机号</div>
                        </template>
                        <el-radio-group v-model="form.hasPhone" class="el-input">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <template v-if="form.hasPhone == 1">
                        <el-form-item label="邮箱 绑定手机号" prop="phone">
                            <template #label>
                                <div class="custom-label">邮箱<br />绑定手机号</div>
                            </template>
                            <el-input v-model="form.phone" placeholder="请输入" maxlength="11" clearable show-word-limit
                                @input="checkPhone"></el-input>
                        </el-form-item>
                        <el-form-item label="绑定手机号所属员工">
                            <template #label>
                                <div class="custom-label">绑定手机号<br />所属员工</div>
                            </template>
                            <el-input v-model="accountName" placeholder="自动识别" style="width: 204px;"
                                disabled></el-input>
                        </el-form-item>
                    </template>
                    <el-form-item label="邮箱备注" prop="remarks">
                        <el-input v-model="form.remarks" placeholder="请输入" clearable maxlength="64" type="textarea"
                            style="width: 204px;" rows="3" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="footer" :class="[isCollapsed ? 'footer-collapsed' : '']">
                <el-button type="info" plain @click="back">返回</el-button>
                <el-button type="primary" plain @click="reset">重置</el-button>
                <el-button type="primary" @click="save" :loading="btnSave">保存</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import { REGEX } from '@/pages/assetManagement/common/consts/regex.js';

export default {
    name: 'workEmailAdd',
    computed: {
        isCollapsed() {
            return this.$store.state.isCollapsed
        }
    },
    data() {
        return {
            form: {
                account: '',
                password: '',
                name: '',
                hasPhone: 1,
                remarks: '',

            },
            btnSave: false,
            rules: {
                account: [
                    { required: true, message: '请输入工作邮箱', trigger: 'blur' },
                    { pattern: REGEX.EMAIL, message: '请输入正确的邮箱', trigger: ['blur', 'change'] }
                ],
                password: [
                    { required: true, message: '请输入邮箱密码', trigger: 'blur' }
                ],
                hasPhone: [
                    { required: true, message: '请选择是否绑定手机', trigger: ['blur', 'change'] }
                ],
                phone: [
                    { pattern: REGEX.PHONE, message: '请输入11位手机号', trigger: 'change' }
                ],
            },
            eye: false,
            accountName: ''
        }
    },
    activated() {
        this.reset()
    },
    created() {
        for (const type in this.dictionaries) {
            this.getDictionaries(type)
        }
    },
    methods: {
        checkPhone(value) {
            if (REGEX.PHONE.test(value)) {
                let account = value
                this.$api.workPhoneFindName({ account }).then(res => {
                    if (res.code == 0) {
                        this.accountName = res.data || '该手机号无登记'
                    } else {
                        this.accountName = '该手机号无登记'
                    }
                })
            } else {
                this.accountName = ''
            }
        },
        onEye() {
            this.eye = !this.eye
        },
        back() {
            this.$router.go(-1)
        },
        reset() {
            this.form = {
                hasPhone: 1
            }
            this.accountName = ''
            this.$refs.form.resetFields()
        },
        save() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.btnSave = true;

                    // 构建附件列表
                    const attachmentList = this.form.attachmentList.map(file => ({
                        name: file.name,
                        url: file.url || '', // 需要先上传文件获取URL，这里假设已有url字段
                        size: Math.round(file.size / (1024 * 1024)), // 转换为MB
                        type: file.type
                    }));

                    // 构建接收人员列表
                    const receiveList = this.form.receivers.map(receiver => ({
                        id: receiver.id,
                        type: receiver.type || 'user', // 默认类型为user
                        name: receiver.name,
                        orgPath: receiver.orgPath || '' // 需要确保有部门路径
                    }));

                    // 构建请求参数
                    const params = {
                        title: this.form.title,
                        content: this.html,
                        categoryId: this.form.category,
                        author: this.form.name,
                        attachmentList: attachmentList,
                        receiveList: receiveList
                        // id: this.form.id // 如果是编辑已有公告，需要传递id
                    };

                    // 调用保存接口
                    this.$api.announcementSave(params)
                        .then(res => {
                            this.btnSave = false;
                            if (res.code === 0) {
                                this.$message({
                                    message: '公告保存成功',
                                    type: 'success'
                                });
                                this.back();
                            } else {
                                this.$message.error(res.msg || '保存失败');
                            }
                        })
                        .catch(err => {
                            this.btnSave = false;
                            this.$message.error('保存失败');
                        });
                }
            });
        },
        //获取字典数据
        getDictionaries(type) {
            if (type && this.dictionaries[type].length > 0) {
                return
            }
            const params = { groupId: type }
            this.$api.dictionaries(params).then(res => {
                this.dictionaries[type] = res.data || []
            }).catch((err) => {
                console.log(err)
            })
        },
    },
}
</script>
<style lang="scss" src="@/pages/assetManagement/common/style/workEmail.scss" scoped />